import _objectSpread from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/map-ai-native/feed-h5/node_modules/.pnpm/@babel+runtime@7.23.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { isBaiduMap, isBaiduMapAuto, hideBackBtn, isIPhone } from '../../utils';
export default {
  props: {
    leftText: {
      type: String,
      default: ''
    },
    newBackBtn: {
      type: Boolean,
      default: false
    },
    // 隐藏返回按钮
    hiddenBackBtn: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: ''
    },
    rightText: {
      type: String,
      default: ''
    },
    titleLeftStyle: {
      type: Object,
      default: () => {}
    },
    titleContentStyle: {
      type: Object,
      default: () => {}
    },
    titleRightStyle: {
      type: Object,
      default: () => {}
    },
    transBgColor: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      titleLeftAndRightWidth: {},
      titleContentWidth: {},
      isBaiduMap: isBaiduMap(),
      isBaiduMapAuto: isBaiduMapAuto(),
      // 是否在车机地图中
      isIPhone: isIPhone()
    };
  },
  methods: {
    handleLeft() {
      this.$emit('handleLeft');
    },
    handleContent() {
      this.$emit('handleContent');
    }
  },
  computed: {
    titleLeftAll() {
      return _objectSpread(_objectSpread({}, this.titleLeftStyle), this.titleLeftAndRightWidth);
    },
    titleContentAll() {
      return _objectSpread(_objectSpread({}, this.titleContentStyle), this.titleContentWidth);
    },
    titleRightAll() {
      return _objectSpread(_objectSpread({}, this.titleRightStyle), this.titleLeftAndRightWidth);
    },
    transBg() {
      return this.transBgColor;
    }
  },
  created() {
    hideBackBtn();
  }
};